// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iJL3-","form":"styles_form__Yr0Ui","title":"styles_title__E2FlU"};